/* eslint-disable react/destructuring-assignment */
import React from 'react';

import {Get} from '@/api/request';
import Button from '@/components/button/Button';
import VideoPlayer from '@/components/videoPlayer/VideoPlayer';
import * as APPDATA from '@/constants/pcConstAppData';
import {EventCheckUpdateSystem, EventLicenseService} from '@/constants/pubSubEnum';
import {consoleLog} from '@/libs/consoleHelper';
import {eventBusObject} from '@/observers/eventBus';

import './WarmingUp.less';

const VideoType = 'video/mp4';

class WarmingUp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      videoSrcList: [],
      hidePlayButton: true,
    };
    this.videoId = 0;
    this.videoPlayerRef = React.createRef();
    this.isWarmingUpFinish = false;
    this._bus = eventBusObject();
    this.successGetStatus = this.successGetStatus.bind(this);
  }

  componentDidMount() {
    // this.updateStatus();
    // this.videoPlayerRef.play();
    this._statusServicePooling = setInterval(() => {
      if (this.isWarmingUpFinish === false) this.updateStatus();
    }, APPDATA.CONFIGURATION.INTERVAL.STATUS_TIME_UPDATE);
  }

  componentWillUnmount() {
    if (typeof this._statusServicePooling !== 'undefined') clearInterval(this._statusServicePooling);
  }

  onEndVideo = () => {
    const nextVideoList = this.state.videoSrcList; // ["http://formulatrix.com/downloads/marketing/videos/pulse/PULSE%20-%20HW%20Prep%20v1.1.mp4","http://www.w3schools.com/html/movie.mp4","http://www.w3schools.com/html/mov_bbb.mp4","http://www.w3schools.com/html/movie.mp4"];

    if (this.videoId < nextVideoList.length) {
      this.videoId++;
      if (this.videoId === nextVideoList.length) this.videoId = 0;

      this.videoPlayerRef.src = `${APPDATA.API.WARMING_UP_VIDEO}/${nextVideoList[this.videoId]}`;
      this.videoPlayerRef.play();
    }
  };

  updateStatus = () => {
    const param = {};
    const passingValue = {};
    Get(APPDATA.API.WARMING_UP_STATUS, param, this.successGetStatus, passingValue);
  };

  finishVideo = () => {
    const param = {};
    const passingValue = {};
    Get(APPDATA.API.WARMING_UP_STOP_VIDEO, param, this.successGetStatus, passingValue);
  };

  successGetStatus = (response) => {
    // status is Idle,WarmingUp,Finisih
    // consoleLog("successGetStatus Warming up",response)
    const status = response.data.Status;
    const videoList = response.data.VideoPath;
    if (status === 'Finish' || status === 'Error') {
      if (APPDATA.CONFIGURATION.ENABLED_UPDATE_SOFTWARE) {
        this._bus.publish(EventCheckUpdateSystem.CheckingVersionUpdate, {IsFromHome: true});
      }
      this._bus.publish(EventLicenseService.initialLicenseService, {isShowTrialModal: true});
      // this._bus.publish(EventLicenseService.TrialLicenseModalService, { isButtonActivateDisable: false });

      window.location.href = APPDATA.HOME_SCREEN_ADDRESS;
      this.isWarmingUpFinish = true;
    } else if (this.state.videoSrcList.length === 0) {
      this.setState({
        videoSrcList: videoList,
      });

      setTimeout(function () {
        consoleLog('Play after 2 second');
        const playPromise = this.playVideo();
        if (playPromise !== null) {
          playPromise.catch(() => {
            consoleLog("Can't play video, automatically. Please Start Manually");
            this.setState({
              hidePlayButton: false,
            });
          });
        }
      }, 1000);
    }
  };

  playVideo = () => this.videoPlayerRef.play();

  manualPlayVideo = () => {
    this.playVideo();
    this.setState({
      hidePlayButton: true,
    });
  };

  render() {
    const {videoSrcList} = this.state;
    const initialsrcVideo = `${APPDATA.API.WARMING_UP_VIDEO}/${videoSrcList[0]}`;
    return (
      <div>
        <div className="warming-up">
          {videoSrcList.length !== 0 && (
            <VideoPlayer
              id="warming-up-player"
              className="warming-up-video"
              controls={false}
              autoPlay
              // eslint-disable-next-line no-return-assign
              ref={(ref) => (this.videoPlayerRef = ref)}
              src={initialsrcVideo}
              type={VideoType}
              onEnded={this.onEndVideo}
              hidePlayButton={this.state.hidePlayButton}
              actionPlayButton={this.manualPlayVideo}
            />
          )}
        </div>
        <div>
          <Button
            className="btn-stop-video"
            label="Skip Video"
            onClick={this.finishVideo}
          />
        </div>
      </div>
    );
  }
}
export default WarmingUp;
